import {
  Card,
  Avatar,
  Typography,
  Button,
  Form,
  Input,
  Row,
  Col,
  Descriptions,
  message,
  Divider,
  Modal,
  Tag,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import ProfileModal from "./modal/profileModal";
import { useDispatch, useSelector } from "react-redux";
import User from "../../models/user/user";

import { updateUserDetails, userDetails } from "redux/roles/userRoleSlice";
import { onlyAlphabets, phoneRegex } from "utilities/regexUtilities";
import { downloadEvent, getInitials } from "utilities/generalUtility";
import InitialAvatar from "common/components/Initials/InitialAvatar";
import Request from "network/request";
import NetworkCall from "network/networkCall";

import ChangePassword from "./changePassword";
import PersonalityTabs from "features/register/personalityTabs";
import { globalSettings } from "redux/settings/settingSlice";
import Payments from "./payments";

const { Title } = Typography;

const tabList = [
  {
    key: "AccountSettings",
    tab: "Account Settings",
  },
  {
    key: "ChangePassword",
    tab: "Change Password",
  },
  {
    key: "Personality",
    tab: "Personality",
  },
  {
    key: "Payments",
    tab: "Payments",
  },
  // {
  //   key: "PaymentMethodtab",
  //   tab: "Payment Method",
  // },
];

export default function AccountSetting() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [isUpdate, setIsUpdate] = useState(true);
  const [isUpdatePassword, setIsUpdatePassword] = useState(true);
  const [isUpdatePayment, setIsUpdatePayment] = useState(true);
  const userData = useSelector(userDetails);
  const dispatch = useDispatch();
  const [activeBtnLoading, setActiveBtnLoading] = useState(false);
  const [update, setUpdate] = useState();
  const [profileImage, setProfileImage] = useState();
  const [isChecked, setIsChecked] = useState(User?.isUserctive());
  const [open, setOpen] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const settings = useSelector(globalSettings);
  const formRef = useRef(null);
  const showModal = (e) => {
    downloadEvent("uploadProfile");
    setIsModalOpen(true);
  };
  useEffect(() => {
    setProfileImage(User.getProfilePicture());
  }, [update, profileImage]);

  const handleChange = () => {
    setIsChecked(!isChecked);
    setOpen(true);
  };

  const handleStatusCancel = () => {
    setOpen(false);
    setIsChecked(!isChecked);
  };

  const handleUserUpdateStatus = async () => {
    setActiveBtnLoading(true);
    try {
      queryParams.set("isActive", isChecked);
      const response = await NetworkCall.fetch(
        Request.updateUserStatus(queryParams.toString())
      );
      // dispatch(fetchUserDetails());
      setActiveBtnLoading(false);
      message.success(response.message);
      User.logoutCall();
    } catch (error) {
      error?.error && message.error(error.message);

      setActiveBtnLoading(false);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.setFieldsValue({
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      emailID: userData?.emailID,
      phoneNumber: userData?.phoneNumber,
    });

    setIsUpdate(true);
    setIsUpdatePassword(true);
    setIsUpdatePayment(true);
  };

  const handleEdit = (value) => {
    // value.isActive = isChecked;
    dispatch(updateUserDetails(value));
    setIsUpdate(!isUpdate);
    // setIsUpdatePassword(!isUpdatePassword);
    // setIsUpdatePayment(!setIsUpdatePayment);
  };
  const [activeTabKey1, setActiveTabKey1] = useState(
    userData?.subscriptionStatus &&
      (userData?.subscriptionStatus === "active" ||
        userData?.subscriptionStatus === "trialing")
      ? "AccountSettings"
      : "Payments"
  );
  const onTab1Change = (key) => {
    setActiveTabKey1(key);
    formRef.current = form1;
  };
  useEffect(() => {
    form.setFieldsValue({
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      emailID: userData?.emailID,
      phoneNumber: userData?.phoneNumber,
      isActive: userData?.isActive,
    });
    // setIsChecked(userData?.isActive);
  }, [userData]);

  const [options, setoption] = useState();
  const [loading, setLoading] = useState(false);

  const fetchPersonalityTypes = async () => {
    try {
      setLoading(true);
      const res = await NetworkCall.fetch(
        Request.getAllPersonalityTypes(),
        false
      );
      setoption(res?.data?.tableListing);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPersonalityTypes();
  }, []);

  const contentList = {
    AccountSettings: (
      <Form
        layout="vertical"
        className="user-form"
        form={form}
        // initialValues={{
        //   remember: true,
        // }}
        onFinish={handleEdit}
        autoComplete="off"
      >
        <Row gutter={23}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              disabled={!User.isUserctive()}
              label={
                <>
                  <div className="acount-setting-label">
                    First Name
                    {/* <i className="icon-edit"></i> */}
                  </div>
                </>
              }
              name="firstName"
              rules={[
                {
                  required: true,
                  message: "Please input your last name!",
                },
                {
                  pattern: new RegExp(onlyAlphabets),
                  message:
                    "Field does not accept numbers,special chracters or spaces",
                },
              ]}
            >
              <Input placeholder="First Name" disabled={isUpdate} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={
                <>
                  <div className="acount-setting-label">
                    Last Name
                    {/* <i className="icon-edit"></i> */}
                  </div>
                </>
              }
              name="lastName"
              rules={[
                {
                  required: true,
                  message: "Please input your last name!",
                },
                {
                  pattern: new RegExp(onlyAlphabets),
                  message:
                    "Field does not accept numbers,special chracters or spaces",
                },
              ]}
            >
              <Input placeholder="Last Name" disabled={isUpdate} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={
                <>
                  <div className="acount-setting-label">
                    Email ID
                    {/* <i className="icon-edit"></i> */}
                  </div>
                </>
              }
              name="emailID"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="Email ID" disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={
                <>
                  <div className="acount-setting-label">
                    Phone Number
                    {/* <i className="icon-edit"></i> */}
                  </div>
                </>
              }
              name="phoneNumber"
              rules={[
                {
                  whitespace: true,
                  message: "Only Spaces are not allowed",
                },

                {
                  pattern: new RegExp(phoneRegex),
                  message: "Please Enter Valid Phone Number",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Enter Mobile Number"
                disabled={isUpdate}
              />
            </Form.Item>
          </Col>

          <Col xs={24} className="forms-button d-flex justify-content-end">
            {!isUpdate && (
              <>
                <Form.Item className="mb-0">
                  <Button
                    ghost
                    size="large"
                    className="cancel"
                    disabled={isUpdate}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Form.Item>
                <Form.Item className="mb-0">
                  <Button
                    type="primary"
                    disabled={isUpdate}
                    size="large"
                    htmlType="submit"
                    onClick={() => {
                      downloadEvent("EditProfileSetting");
                    }}
                  >
                    Save Changes
                  </Button>
                </Form.Item>
              </>
            )}
            {isUpdate && (
              <Form.Item className="mb-0">
                <Button
                  disabled={!User.isUserctive()}
                  // style={{ border: "#110B79 1px solid" }}
                  // disabled={!isUpdate}
                  size="large"
                  onClick={() => setIsUpdate(!isUpdate)}
                >
                  Edit
                </Button>
              </Form.Item>
            )}
          </Col>
        </Row>
      </Form>
    ),
    ChangePassword: (
      <ChangePassword
        isUpdatePassword={isUpdatePassword}
        setIsUpdatePassword={setIsUpdatePassword}
        userData={userData}
      />
    ),
    Personality: (
      <PersonalityTabs
        options={options}
        loading={loading}
        userType={userData?.personalityProfileType ?? 99}
      />
    ),
    PaymentMethodtab: (
      <Form
        disabled={!User.isUserctive()}
        name="basic"
        layout="vertical"
        className="user-form"
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
      >
        <Row gutter={23}>
          <Col xs={24} sm={24}>
            <Form.Item
              label={
                <>
                  <div className="acount-setting-label">
                    Card Information<i className="icon-edit"></i>
                  </div>
                </>
              }
              name="CardInformation"
            >
              <Descriptions size="middle" bordered span={2}>
                <Descriptions.Item span={24}>XXXX XXXX XXXX</Descriptions.Item>
                <Descriptions.Item span={2}>07 / 2022</Descriptions.Item>
                <Descriptions.Item span={2}>07 / 2022</Descriptions.Item>
              </Descriptions>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={
                <>
                  <div className="acount-setting-label">
                    Name on Card<i className="icon-edit"></i>
                  </div>
                </>
              }
              name="nameoncard"
              rules={[
                {
                  // required: true,
                  message: "Please input your name",
                },
              ]}
            >
              <Input placeholder="Name on Card" disabled={isUpdatePayment} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Country or Region"
              name="countryregion"
              rules={[
                {
                  message: "Please input your Country Region",
                },
              ]}
            >
              <Input placeholder="Country" disabled={isUpdatePayment} />
            </Form.Item>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            className="forms-button d-flex justify-content-end"
          >
            {!isUpdatePayment && (
              <>
                <Form.Item className="mb-0">
                  <Button
                    className="cancel"
                    ghost
                    size="large"
                    htmlType="submit"
                    onClick={() => setIsUpdatePayment(!isUpdatePayment)}
                  >
                    Cancel
                  </Button>
                </Form.Item>
                <Form.Item className="mb-0">
                  <Button
                    type="primary"
                    disabled
                    size="large"
                    htmlType="submit"
                  >
                    Save Changes
                  </Button>
                </Form.Item>
              </>
            )}

            {isUpdatePayment && (
              <Form.Item className="mb-0">
                <Button
                  disabled={!User.isUserctive()}
                  size="large"
                  onClick={() => setIsUpdatePayment(!isUpdatePayment)}
                >
                  Edit
                </Button>
              </Form.Item>
            )}
          </Col>
        </Row>
      </Form>
    ),
    Payments: <Payments userData={userData} settings={settings} />,
  };

  return (
    <>
      <Card className="account-setting-card" title="Account Settings">
        <div className="profile-wrapper">
          <Card className="profile-card">
            <div className="position-relative profile-upload">
              <Avatar
                className="avatar-img"
                size={190}
                src={
                  profileImage === "" ? (
                    <InitialAvatar
                      initials={getInitials(
                        userData?.firstName,
                        userData?.lastName
                      )}
                      check={"190"}
                    />
                  ) : (
                    profileImage
                  )
                }
              />
              <Button
                type="link"
                disabled={!User.isUserctive()}
                onClick={showModal}
                className="modal-open-btn"
                icon={<i className="icon-camera"></i>}
              ></Button>
              <ProfileModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                firstName={userData?.firstName}
                lastName={userData?.lastName}
              />
            </div>

            <Title level={4}>
              {userData?.firstName + " " + userData?.lastName}
            </Title>

            <Button
              type="primary"
              className="upload-btn"
              size="large"
              disabled={!User.isUserctive()}
              onClick={(e) => showModal(e)}
            >
              Upload New Picture
            </Button>
          </Card>
          <Card
            className="tab-card"
            tabList={
              settings?.EnableAI === "1"
                ? tabList
                : tabList.filter((tab) => tab.key !== "Personality")
            }
            activeTabKey={activeTabKey1}
            onTabChange={(key) => {
              onTab1Change(key);
            }}
          >
            {contentList[activeTabKey1]}
          </Card>
          <Modal
            className="create-diary-modal cm-modal "
            centered
            open={open}
            // onOk={handleUserUpdateStatus}
            onCancel={handleStatusCancel}
            closeIcon={<i className="icon-close"></i>}
            footer={null}
            // footer={[
            //   <Button type="primary">Post Draft Entries</Button>,
            //   <Button ghost key="back" onClick={handleCancel}>
            //     Cancel
            //   </Button>,
            // ]}
          >
            <div className="common-modal-header">
              <i className="modal-icon icon-draft"></i>
              <Title level={4}>
                {!isChecked ? "Deactivate Account" : "Activate Account"}
              </Title>
            </div>
            <Divider />
            <div className="modal-para">
              <Title level={4}>
                {" "}
                {`Are you sure you want to ${
                  !isChecked ? "Deactivate" : "Activate"
                } your Account?`}
              </Title>
              {/* <p>
                  Your diary will be locked for your co-diarists and they will
                  not be able to make any entry while diary is locked.
                </p> */}
            </div>
            <div class="add-entry-footer">
              <Button
                type="primary"
                onClick={handleUserUpdateStatus}
                loading={activeBtnLoading}
              >
                Yes
              </Button>
              <Button ghost key="back" onClick={handleStatusCancel}>
                No
              </Button>
              <div>
                {/* <Checkbox className="mt-2 text-center">
              Don’t show it again
            </Checkbox> */}
              </div>
            </div>
          </Modal>
        </div>
      </Card>
    </>
  );
}
